{
  "endTime": "結束時間",
  "startTime": "開始時間",
  "time": "時間"
}
